// extracted by mini-css-extract-plugin
export default {"radio":"style_radio__gcdxj","dot":"style_dot__agtLj","active":"style_active__CeX-w"};